<template>
    <figure v-lazyload class="relative w-full h-full">
        <LoaderSpinner class="flex justify-center items-center w-full h-full" />
        <img
            class="absolute inset-0 w-full h-full object-cover opacity-0"
            :data-url="source"
            :data-srcset="sourceSet"
            sizes="auto"
            :alt="alt"
        />
    </figure>
</template>

<script>
import LoaderSpinner from './LoaderSpinner';

export default {
    name: 'ImageItem',
    components: {
        LoaderSpinner
    },
    props: {
        source: {
            type: String,
            required: true
        },
        sourceSet: {
            type: String,
            required: true
        },
        alt: {
            type: String,
            required: true
        }
    }
};
</script>
